import { IconButton } from '@chakra-ui/react'
import { HamburgerIcon } from '@chakra-ui/icons'

interface PageHeaderProps {
  onOpen: () => void
}

export default function PageHeader({ onOpen }: PageHeaderProps) {
  return (
    <IconButton
      aria-label="Open menu"
      icon={<HamburgerIcon />}
      onClick={onOpen}
      position="fixed"
      top={4}
      left={4}
      zIndex={3}
      bg="whiteAlpha.200"
      backdropFilter="blur(10px)"
      border="1px solid"
      borderColor="whiteAlpha.300"
      color="white"
      _hover={{ bg: 'whiteAlpha.300', transform: 'scale(1.05)' }}
      size={{ base: 'sm', md: 'lg' }}
    />
  )
}
